module.exports = __webpack_public_path__ + "static/media/SupplyChain1.22f72d64.png";